import { usePreference } from "@hooks/index.ts";

const useServerInfo = () => {
  const { serverInfo } = usePreference();
  return serverInfo;
};

export default useServerInfo;
